/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import { useNavigate, Link } from 'react-router-dom';

const Step1 = ({ onNext, cid, role,token,formData, setFormData }) => {

    const initialState = {
        country: "",
        type: "",
        sequential: '',        
        qty: 0
    };
    const [showNoAccessMessage,setShowNoMessageAccess] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [searchInstrunction, setSearchInstrunction] = useState(false);
    const [orderInstrunction, setOrdernstrunction] = useState(false);
    const [stateInstrunction, setStateInstrunction] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
  
    const [showValidationError, setShowValidationError] = useState(false);
    const [searchNumberList, setSearchNumberList] = useState([]);
    const [reserveNumberList, setReserveNumberList] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [companyList, setcompanyList] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [showCustomerValidationError, setShowCustomerValidationError] = useState(false);
    const [showSearchNumber, setShowSearchNumber] = useState(false);
    const [rows, setRows] = useState([{ ...initialState }]);
    
   
    useEffect(() => {
        if(formData.reserveNumberList){
            console.log(formData.reserveNumberList);
            setReserveNumberList(formData.reserveNumberList);
        }
        if(formData.selectedCompany){
            console.log(formData);
            setSelectedValue(formData.selectedCompany);
        }
        if(role > 2){
            setSelectedValue(cid);
            setFormData(prev => ({ ...prev, selectedCompany: cid }));

            
        }
        console.log(role);
        
        // Make the API call when the component mounts
        getTypeList();
        if(token){
            getCustomerNameList();
            // checkAccess();
        }
    }, [token]);

    useEffect(() => {
        console.log(selectedValue);
        console.log(countryList)
        if(selectedValue && countryList.length == 0){
            setShowNoMessageAccess(true);
        }
        if(selectedValue && countryList.length > 0){
            setShowNoMessageAccess(false);
        }
    }, [selectedValue, countryList]);

   
    
    const getCountryList = async () => { // Renamed from getCountryList to getCountryList
        try {
            let url = `${baseUrl}/countries`;
            // If role > 2, pass selectedValue (company ID) as a query parameter
            // Ensure selectedValue is not empty before adding it
            if (selectedValue) {
                url = `${baseUrl}/countries?cid=${selectedValue}`;
            }

            const response = await axios.get(url);
            const allArray = response.data;
             
            setCountryList(allArray.list);
            
        } catch (error) {            
           console.log(error);           
        }  
    };

    const getTypeList = async () => { 
        try {
           
            const response = await axios.get(`${baseUrl}/international-order-type`);
            const allArray = response.data;
            
            setTypeList(allArray.list);
        } catch (error) {            
           console.log(error);           
        }
    }

    const getCustomerNameList = async () => {
        try {
            // setApiCallCount((prevCount) => prevCount + 1);
            const response = await axios.get(`${baseUrl}/active-user-company`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            const allArray = response.data.filter(item => item.id !== 1);
            console.log(response.data.filter(item => item.id !== 1));
            // setApiResponseCount((prevCount) => prevCount + 1);
            setcompanyList(allArray);
        } catch (error) {
            // setLoading(false);
            
           console.log(error);
            
        }
    };
    
    // New useEffect for getCountryList to react to role and selectedValue changes
    useEffect(() => {
        if (token && selectedValue) { // Ensure token is available before making the call
            getCountryList();
        }
    }, [token, role, selectedValue]); // Add role and selectedValue as dependencies

   
   
    const handleSearch = async(e) => {
        e.preventDefault();
        const errors = rows.reduce((acc, obj, index) => {
            if (obj.qty === undefined || !obj.qty || parseInt(obj.qty, 10) <= 0) {
              acc.push(`\nRow ${index + 1}: Please enter a valid quantity`);
            }
            if (!obj.country) {
              acc.push(`\nRow ${index + 1}: Country is required`);
            }
            if (!obj.type) {
              acc.push(`\nRow ${index + 1}: Type is required`);
            }
            return acc;
        }, []);
        if (errors.length > 0) {
            alert(errors);
            return;
        }
          
        
        try {
            setButtonDisabled(true);
            setPopupOpen(true);
            const response = await axios.post(`${baseUrl}/get-search-international-number`, {rows:rows},{
                headers: {
                    Authorization: `Bearer ${token}`
                }  
            });
            const allArray = response.data;
            
            const updatedRows = rows.map((row,index) => ({ ...row, result: allArray[1]?.length || row.result }));
            setRows(updatedRows);
            
            setButtonDisabled(false);
            setPopupOpen(false);
            setSearchNumberList(allArray.result || []);
            setShowSearchNumber(true);
            
        } catch (error) {
           console.log(error);
           setPopupOpen(false);           
        }
           
    };

    const handleClearSearch = async(e) => {
        e.preventDefault();        
        setRows([{ ...initialState }]);
    };

    const handleCheckboxChange = (event, item) => {
        const isChecked = event.target.checked;
       
        if (isChecked) {
            setSelectedItems(prevSelected => [...prevSelected, { tn: item.tn_number }]);
        } else {
            setSelectedItems(prevSelected =>
                prevSelected.filter(tnObj => tnObj.tn !== item.tn_number)
            );
        }
    };

    const handleSelectAll = async(e) => {
        e.preventDefault();
        const allPhoneNumbers = searchNumberList.map(item => ({ tn: item.tn_number }));
        try {

            if (formData.reserveNumberList) {
                
            
                const mergedNumbers = [...formData.reserveNumberList, ...searchNumberList];
                const uniqueArray = [...mergedNumbers.reduce((map, item) => map.set(item.tn_number, item), new Map()).values()];
                
                setSelectedItems(uniqueArray);
                setReserveNumberList(uniqueArray);
                setFormData({ ...formData, reserveNumberList: uniqueArray });
              } else {
                // If formData.reserveNumberList doesn't exist, set allPhoneNumbers
                setSelectedItems(allPhoneNumbers);
                setReserveNumberList(searchNumberList);
                setFormData({ ...formData, reserveNumberList: searchNumberList });
              }
               
            } catch (error) {
                // setLoading(false);
               console.log(error);
                // if (error.response) {
                //     // setError("Unauthorized");
                //     navigate("/");  
                //     window.location.reload();
                // }
            }
    };

    const handleClearAll = async (e) => {
        e.preventDefault();
        setSelectedItems([]); 
    }

    const handleAddSelected = async(e) => {
        e.preventDefault();
        if (selectedItems.length === 0) {
            alert('Please select at least one item to add.');
            return;
        }
        
        

        // Perform reservation API call using selectedItems array

        try {

            const matchingObjectsArray = [];
            selectedItems.forEach(selectedItem => {
                const selectedPhoneNumber = selectedItem.tn;
                const matchingObject = searchNumberList.find(item => item.tn_number === selectedPhoneNumber);
                  
                if (matchingObject) {
                    matchingObjectsArray.push(matchingObject);
                }
            
            });

            if (formData.reserveNumberList) {
                
                const mergedNumbers = [...formData.reserveNumberList, ...matchingObjectsArray];
                const uniqueArray = [...mergedNumbers.reduce((map, item) => map.set(item.tn_number, item), new Map()).values()];
                
                // setSelectedItems(uniqueArray);
                setReserveNumberList(uniqueArray);
                setFormData({ ...formData, reserveNumberList: uniqueArray });
            }else{
                setReserveNumberList(matchingObjectsArray);
                setFormData({ ...formData, reserveNumberList: matchingObjectsArray });
            }
            
                
            } catch (error) {
                // setLoading(false);
               console.log(error);
                // if (error.response) {
                //     // setError("Unauthorized");
                //     navigate("/");  
                //     window.location.reload();
                // }
            }
    };

    const toggleSearchVisible = () => {
        setSearchInstrunction(!searchInstrunction);
    };

    const toggleOrderVisible = () => {
        setOrdernstrunction(!orderInstrunction);
    };

    const toggleStateInstruction = () => {
        setStateInstrunction(!stateInstrunction);
    };

    const handleRemoveAll = async(e) => {
        e.preventDefault();
        setSelectedItems([]);
        setReserveNumberList([]);
        setFormData({ ...formData, reserveNumberList: [] });
        
    };

    const handleRemoveSelected = async(e, item) => {
        e.preventDefault();

        setSelectedItems(prevSelected =>
            prevSelected.filter(tnObj => tnObj.tn !== item.tn_number)
        );
        const updatedList = reserveNumberList.filter(tnObj => tnObj.tn_number !== item.tn_number);
        // console.log(updatedList);
        setReserveNumberList(updatedList);
        const updateData = { ...formData, reserveNumberList: updatedList };
        setFormData(updateData);
        
        // setSelectedItems([]);
        // setReserveNumberList([]);
    };

   
    const handleCompanyChange = (e) => {
        setSelectedValue(e.target.value);        
        setFormData({ ...formData, selectedCompany: e.target.value });
    };

    const handleNext = (e) => {
        e.preventDefault();
        let hasCustomerValidationError = false;
        let hasValidationError = false;
        if( role <= 2 && selectedValue === ''){
            setShowCustomerValidationError(true);
            hasCustomerValidationError = true;
        }
        console.log(selectedValue);
        console.log(companyList);
        const selectedCompany = companyList.find(comp => comp.id == selectedValue);
        if(!selectedCompany?.short_name){
            alert("Please enter company short name");
        }
        if (reserveNumberList.length === 0) {
          setShowValidationError(true);
          hasValidationError = true;
        } 
        if (!hasCustomerValidationError && !hasValidationError && selectedCompany.short_name) {
            onNext();
        }
    };
    

    const handleInputChange = (e, rowIndex) => {
        const { name, value, type, checked } = e.target;
        const newRows = [...rows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          [name]: type === 'checkbox' ? checked : value,
        };
        setRows(newRows);
      };

    const handleAddRow = () => {
        setRows([...rows, { ...initialState }]);
    };

    const handleDeleteRow = (e, rowIndex) => {
        e.preventDefault();      
        const newData = rows.filter((_, index) => index !== rowIndex);
        setRows(newData);
    }

    return(
        
    <>
        {popupOpen && (
            <div className='overlay'><div className="custom-loader"></div></div> // Display the loader while loading is true
        ) }
        <div className="row">
            <div className="col-6">
                <div className="left-title">
                    <h1>International Number Order
                    <span><img src={`${process.env.PUBLIC_URL}/images/view.png`} onClick={toggleStateInstruction} style={{ cursor: 'pointer' }} /></span> </h1>                                      
                </div>                
            </div>            
            <div className="col-6">

            </div>            
        </div>
        {/* {stateInstrunction && <div className="common-white-shadow-background setting-section">
            <div className="row">                
                <div className="introducebpx">
                    <p><strong>Instructions</strong></p>
                    <p>If you would like to limit the Lata and/or Rate Center for the numbers, please enter those values as well, otherwise leave them set to ##. <br />
                     If you would like the numbers returned to be only those which have no gaps between them, select "Sequential". <br />  Then select "Search" and the available numbers will be shown below.</p>
                </div>
            </div>
        </div>} */}
        {role <= 2 && <div className="common-white-shadow-background setting-section">
            <div className="row">
                <h3 className='comapny-label'>Select Company</h3>
                <div className="inputbox">
                    <select name="" id=""  value={selectedValue} onChange={(e) => handleCompanyChange(e)}>
                        <option value="">Select Company</option>
                        {companyList.map((comp) => (                                                                    
                                <option key={comp.id} value={comp.id}>
                                    {comp.cname}
                                </option>  
                            ))}
                     
                    </select>
                </div>
            </div>
            {showCustomerValidationError && (
        <p className="error">Please select a value from the dropdown.</p>
      )}
        </div>}        
        
            
            
         
        {selectedValue && !showNoAccessMessage && <div className="common-white-shadow-background setting-section tableinput-section first-number-table">
                
                    <div className="row">
                        <table className="tablebox">
                            <thead>
                                <tr>
                                    <th>Country<span>*</span></th>
                                    <th>Type<span>*</span></th>
                                    <th>Qty<span>*</span></th>                                    
                                    <th>Sequential</th>                                   
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((rowData, index) => (
                                    <tr key={index}>
                                      <td>
                                        <select
                                          name="country"
                                          value={rowData.country}
                                          onChange={(e) => {handleInputChange(e, index);}}
                                        >
                                         <option value="">##</option>
                                        {countryList.map((country) => (                                                                    
                                            <option key={country.id} data-id={country.id} value={country.short_name}>
                                                {country.short_name}-{country.name}
                                            </option>  
                                        ))}
                                        </select>
                                      </td>
                                      <td>
                                        <select
                                          name="type"
                                          value={rowData.type}
                                          onChange={(e) => {handleInputChange(e, index);}}
                                        >
                                          <option value="">##</option>
                                          {typeList.map((type) => (                                                                    
                                            <option key={type.id} data-id={type.id} value={type.name}>
                                                {type.name}
                                            </option>  
                                        ))}
                                        </select>
                                      </td>                                      
                                      <td>
                                        <input
                                          type="number"
                                          name="qty"
                                          onChange={(e) => handleInputChange(e, index)}
                                          value={rowData.qty === 0 ? '' : rowData.qty}
                                          placeholder='Qty'
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          name="sequential"
                                          onChange={(e) => handleInputChange(e, index)}
                                          checked={rowData.sequential}
                                        />
                                      </td>                                      
                                      <td>{index > 0 && <a className="search" onClick={(e) => handleDeleteRow(e, index)}  href='#'>Delete Row</a>}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>                
                    </div>
                               
                <div className="row">
                    <div className="newrow-section">
                    {(<a className="newrow" href="#" onClick={handleAddRow}>+ Add Row</a>)}
                        <a className="search" onClick={handleClearSearch} href='#'>Clear</a>
                        <a className={buttonDisabled ? 'search disabled-link' : 'search'} onClick={handleSearch} href='#'>Search</a>
                    </div>
                </div>    
        </div>}
        
       
            
        <div className="row">
            {showSearchNumber && <div className="col-6">
                <div className="common-white-shadow-background setting-section haft-whitebox">
                    <div className='order-queue'>
                        <h3>Search Results 
                        <span><img src={`${process.env.PUBLIC_URL}/images/view.png`} onClick={toggleSearchVisible} style={{ cursor: 'pointer' }} /></span>
                            {/* <span onClick={toggleSearchVisible} style={{ cursor: 'pointer' }}>
                                {searchInstrunction ? '👁️' : '👁️'}
                            </span> */}
                        </h3>
                        <h3>Selected Numbers: {selectedItems.length}</h3>
                    </div>
                    {searchInstrunction && (
                        <>
                            <div className="introducebox">
                                <p><strong>Instructions</strong></p>
                                <p>Use the checkbox to add the telephone numbers from this table to the order.<br />  Once you are done selecting the numbers you would like to add to the order, select "Add Selected". <br />  If you would like to add all the numbers listed to the order, select "Add All".</p>
                            </div>                            
                        </>
                    )}
                    <div className="newrow-section">
                        <a className="newrow" href="#" onClick={(e) => {handleSelectAll(e);handleClearAll(e)}}>Add All</a>
                        <a className='search' href="#" onClick={handleClearAll}>Clear All</a>
                        <a className="delete" href="#" onClick={(e) => {handleAddSelected(e);handleClearAll(e) }}>Add Selected</a>
                    </div>
                    <table className="tablebox create-order-table">
                        <thead>
                            <tr>
                                <th>Country Code</th>
                                <th>Area Code</th>
                                <th>City</th>
                                <th>Tel Number</th>
                                <th>Type</th>
                                <th>Add To Queue</th>
                            </tr>
                        </thead>
                        <tbody>
                            {searchNumberList.length > 0 ? (searchNumberList.map((item, index) => 
                             <tr key={index}>
                             <td>{item.country}</td>
                             <td>{item.area_code}</td>
                             <td>{item.city}</td>
                             <td>{item.tn_number}</td>
                             <td>{item.did_type}</td>
                             <td><input  checked={selectedItems.some(tnObj => tnObj.tn === item.tn_number)}
                                    onChange={event => handleCheckboxChange(event, item)} type="checkbox" name="" /></td>
                         </tr>)):(
                            <tr >
                            <td colSpan={6} className='no-result'>No Result found</td>
                           
                        </tr>
                         )}
                           
                        </tbody>
                    </table>
                </div>
            </div>}
            {reserveNumberList.length > 0 && <div className="col-6">
                <div className="common-white-shadow-background setting-section haft-whitebox">
                    <div className='order-queue'>
                    <h3>Order Queue
                    <span><img src={`${process.env.PUBLIC_URL}/images/view.png`} onClick={toggleOrderVisible} style={{ cursor: 'pointer' }} /></span>
                        {/* <span onClick={toggleOrderVisible} style={{ cursor: 'pointer' }}>
                            {orderInstrunction ? '👁️' : '👁️'}
                        </span> */}
                    </h3>
                    <h3>Tel Numbers: {reserveNumberList.length}</h3>
                    </div>
                    {orderInstrunction && (
                        <>
                            <div className="introducebox">
                                <p><strong>Instructions</strong></p>
                                <p>Use 'X' icons to remove Tel Numbers from this table, if you don't want to Order them. <br />
                                    To Order the Numbers in this table: Click the "Next" button.</p>
                                    {/* <p>Reserved TN(s) will remain in the Order Queue for 4 hours. If an order is not generated for the reserved TN(s) within 4 hours, the number(s) will be returned to an Available status and no longer available on your account.</p> */}
                            </div>
                        </>
                    )}
                    
                    <div className="newrow-section footer-row">
                        <a className="delete" onClick={handleRemoveAll} href="#">Remove All</a>
                        <Link className="Cancel" to={"/number-management"}>Cancel</Link>
                        <a href="#" onClick={handleNext} className="next">Next</a>
                    </div>
                    <table className="tablebox create-order-table">
                        <thead>
                            <tr>
                                <th>Country Code</th>
                                <th>Area Code</th>
                                <th>City</th>
                                <th>Tel Number</th>
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                        {reserveNumberList.map((item, index) => 
                             <tr key={index}>
                             <td>{item.country}</td>
                             <td>{item.area_code}</td>
                             <td>{item.city}</td>
                             <td>{item.tn_number}</td>
                             
                             <td><img src="images/bx-x-circle.png" onClick={event => handleRemoveSelected(event, item)} alt="" /></td>
                         </tr>)}
                            
                        </tbody>
                    </table>
                </div>
            </div>}
        </div>
        {showValidationError && <div className="error">Please add at least one reserve number.</div>}
        {selectedValue && showNoAccessMessage && 
        <div className="common-white-shadow-background setting-section">
            <div className="row error">You don't have access to the features.</div>
        </div>}
       
    </>)
};

export default Step1;